import { createObj } from "../fable_modules/fable-library-js.4.19.3/Util.js";
import { map } from "../fable_modules/fable-library-js.4.19.3/Array.js";
import { toArray } from "../fable_modules/fable-library-js.4.19.3/Map.js";

export function ofMap() {
    return (arg_1) => createObj(map((tupledArg) => [tupledArg[0], tupledArg[1]], toArray(arg_1)));
}

